import React, { useEffect, useRef, useState } from "react";
import { useSelector } from "react-redux";
import useSnackbar from "../../hooks/useSnackbar";
import AgGridPaginatedTable from "../../components/AgGridPaginatedTable";
import { Menu } from "@mui/material";
import MenuItem from "@mui/material/MenuItem";
import { transactionTotalTable } from "../../config/grid-column-defs";
import { getTransactionTotalComparison } from "../../api/transaction-total";
import { slugMap } from "../../config/slug-config";
import { useParams } from "react-router-dom";
import { Box, Grid, Typography, Button, Paper, TextField } from "@mui/material";
import "react-datepicker/dist/react-datepicker.css";

export default function TransactionTotal() {
  const [anchorEl, setAnchorEl] = useState(null);
  const docuRef = useRef();
  const [MemoChecked, setMemoChecked] = useState(false);
  const [docuChecked, setdocuChecked] = useState(false);
  const [statusChecked, setStatusChecked] = useState(false);
  const [yearChecked, setYearChecked] = useState(false);
  const [error, setError] = useState("");
  const open1 = Boolean(anchorEl);
  const handleClick1 = (event) => {
    setAnchorEl(event.currentTarget);
  };
  const handleClose1 = (e) => {
    setInputSearch({})
  //  setAnchorEl(null);
  };

  const snackbar = useSnackbar();
  const { data: user } = useSelector((state) => state.user);
  const [onInputSearch, setInputSearch] = useState({});
  const [searchInputValue, setSearchValue] = useState("");
  const params = useParams();
  //console.log(params.slug);
  const [tableRefreshCount, setTableRefreshCount] = useState(0);
  function refreshTable() {
    setTableRefreshCount((prev) => prev + 1);
  }
  useEffect(() => {
    setInputSearch({});
    setSearchValue("");
  }, [params.slug]);

  async function getTransactionTotalComparisonData(limit, offset) {
    try {
      const { data } = await getTransactionTotalComparison(user?.token,
        onInputSearch
          ? {
            limit, offset,
            ...onInputSearch,
          }
          : {
            limit, offset,
          }
      );
      return { rows: data.data, total: data.total, error: false };
    } catch (error) {
      console.log(error);
      snackbar.showError("Error In Loading Data.");
      return { error: true };
    } finally {
      // setLoading(false)
    }
  }

  function isStringInteger(value) {
    return (
      Number.isInteger(parseInt(value)) && value === parseInt(value).toString()
    );
  }

  const InputSearch = (event) => {
    if (isStringInteger(event.target.value) || docuChecked) {
      setInputSearch({ documentno: event.target.value });
      setSearchValue(event.target.value);
    } else if (event.target.value.includes("/")) {
      setInputSearch({ datefrom: event.target.value });
    } else if (MemoChecked) {
      setInputSearch({ memo: event.target.value });
    }
    if (!statusChecked && !yearChecked) {
      setInputSearch({ documentno: event.target.value });
      setSearchValue(event.target.value);
    }

    if (!event.target.value.includes("-")) {
      setSearchValue(event.target.value);
    }
  };

  return (
    <>
      <Paper sx={{ borderRadius: "8px", border: "1px solid #1615131a;" }}>
        <Box
          display="flex"
          alignItems="center"
          justifyContent="space-between"
          p={1}
        >
          <Typography component="h5" fontWeight={500} className="pageHeading1">
            Transaction Total
          </Typography>
          {/*  <Link to="/transaction-type">
            <Button size="small" className="backBtn">
              Go Back
            </Button>
          </Link>*/}
        </Box>

        <Box className="filter-box">
          <Grid container alignItems="center">
            <Grid item md={10} sm={12} xs={12}>
              <Grid container alignItems="center">
                {/* <Grid item md={1} sm={1} xs={1}>
                  <Button
                    id="basic-button1"
                    sx={{ color: "black", fontWeight: "600" }}
                    aria-controls={open1 ? "basic-menu1" : undefined}
                    aria-haspopup="true"
                    aria-expanded={open1 ? "true" : undefined}
                    onClick={handleClick1}
                  >
                    <SearchIcon /> <KeyboardArrowDownIcon />
                  </Button>

                  <Menu
                    id="basic-menu1"
                    anchorEl={anchorEl}
                    open={open1}
                    MenuListProps={{
                      "aria-labelledby": "basic-button1",
                    }}
                  >
                    <MenuItem>
                      <Box>
                      <Checkbox
                        name="status"
                        checked={statusChecked}
                        ref={docuRef}
                        onClick={handleClose1}
                      />
                      Status
                      </Box>
                      <Box
                        style={{
                          display: "flex",
                          justifyContent: "end",
                          position: "relative",
                          top: "-22px",
                          left: "15px",
                        }}
                      >
                        <svg
                          onClick={handleClose1}
                          fill="none"
                          stroke="currentColor"
                          strokeWidth="1.5"
                          viewBox="0 0 24 24"
                          xmlns="http://www.w3.org/2000/svg"
                          aria-hidden="true"
                          height={25}
                        >
                          <path
                            strokeLinecap="round"
                            strokeLinejoin="round"
                            d="M6 18L18 6M6 6l12 12"
                          ></path>
                        </svg>
                      </Box>
                    </MenuItem>
                    <MenuItem>
                      <Checkbox
                        name="year"
                        checked={yearChecked}
                        ref={docuRef}
                        onClick={handleClose1}
                      />
                      Year
                    </MenuItem>
                  </Menu>
                </Grid> */}
                <Grid item md={9} sm={8} xs={9} alignItems="center" display="flex">
                  <TextField
                    type="text"
                    size="small"
                    id="outlined-basic"
                    //placeholder={`${statusChecked ? "Status" : "Status"}`}
                    label="Status"            
                    name={yearChecked ? "year" : ""}
                    variant="outlined"
                    value={onInputSearch?.status ? onInputSearch?.status :""}
                    onChange={(e) => setInputSearch({ ...onInputSearch, status: e.target.value })}
                    sx={{ pr: 1 }}
                  />
                  <Box style={{ display: "flex", gap: "5px", width: "200px", justifyItems: "center",
                      alignItems: "center", marginleft: "20px", }}>
                    <TextField style={{ backgroundColor: "#FFF"}}
                      id="outlined-select-currency"
                      value={onInputSearch?.year ? onInputSearch?.year :""}
                      select
                      label="Year"
                      fullWidth
                      onChange={(e) => {
                        setInputSearch({ ...onInputSearch, year: e.target.value });
                      }}
                      size="small"
                    >
                      <MenuItem value="2023">Year 2023</MenuItem>
                      <MenuItem value="2022">Year 2022</MenuItem>
                      <MenuItem value="2021">Year 2021</MenuItem>
                      <MenuItem value="2020">Year 2020</MenuItem>
                      <MenuItem value="2019">Year 2019</MenuItem>
                      <MenuItem value="2018">Year 2018</MenuItem>
                      <MenuItem value="2017">Year 2017</MenuItem>
                      <MenuItem value="2016">Year 2016</MenuItem>
                      <MenuItem value="2015">Year 2015</MenuItem>
                      <MenuItem value="2014">Year 2014</MenuItem>
                    </TextField>
                  </Box>
                  <Button
                    size="small"
                    type="button"
                    sx={{ color: "black", fontWeight: "600" }}
                    onClick={(e) => handleClose1(e)}
                  >
                    Reset
                  </Button>
                  {error && <p>{error}</p>}
                </Grid>
              </Grid>
            </Grid>
          </Grid>
        </Box>
        <AgGridPaginatedTable
          getTableRows={getTransactionTotalComparisonData}
          columns={transactionTotalTable}
          perPage={20}
          refreshCounter={tableRefreshCount}
          onInputSearch={onInputSearch}
        />
      </Paper>
    </>
  );
}
